<template>
  <div>

    <Row class="search-con">
      <Col span="24">
      <Button @click="backHistory" class="search-btn">返回</Button>
      <label class="search-label" style="margin-left: 20px;">需要翻译成:</label>
      <Input v-model="language" placeholder="填写语言" class="search-input"></Input>

      <Button style="margin-left: 20px;" type="info" :loading="loading" @click="all_translate_text">
        <span v-if="!loading">全部翻译</span>
        <span v-else>翻译中...</span>
      </Button>

      <Button style="margin-left: 20px;" type="info" :loading="keep_loading" @click="keep_translate_text">
        <span v-if="!keep_loading">继续翻译</span>
        <span v-else>翻译中...</span>
      </Button>

      </Col>
    </Row>

    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">
      <FormItem label="视频标题" prop="org_video_title">

        <Col span="18">
        <Input v-model="formValidate.org_video_title" type="textarea" placeholder="请填写视频标题"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[1]" @click="translate_text(formValidate.org_video_title, 1)">
          <span v-if="!loadding_array[1]">翻译</span>
          <span v-else>翻译中...</span>
        </Button>
        </Col>

        <Col span="2" offset="1">
        <Button type="primary" @click="handleSubmit('formValidate')" style="margin-left: 8px">保存</Button>
        </Col>

      </FormItem>

      <FormItem label="翻译后视频标题" prop="translate_video_title">
        <Col span="18">
        <Input v-model="formValidate.translate_video_title" type="textarea" placeholder="请填写视频标题"></Input>
        </Col>
      </FormItem>

      <FormItem label="切片标题">

        <Col span="18">
        <Input v-model="formValidate.org_title" type="textarea" placeholder="请填写切片标题"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[3]" @click="translate_text(formValidate.org_title, 3)">
          <span v-if="!loadding_array[3]">翻译</span>
          <span v-else>翻译中...</span>
        </Button>
        </Col>

      </FormItem>

      <FormItem label="翻译后切片标题">
        <Col span="18">
        <Input v-model="formValidate.translate_title" type="textarea" placeholder="请填写翻译后的切片标题"></Input>
        </Col>
      </FormItem>

      <FormItem label="封面标题">

        <Col span="18">
        <Input v-model="formValidate.cover_title" type="textarea" placeholder="请填写封面标题"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[6]" @click="translate_text(formValidate.cover_title, 6)">
          <span v-if="!loadding_array[6]">翻译</span>
          <span v-else>翻译中...</span>
        </Button>
        </Col>

      </FormItem>

      <FormItem label="翻译后封面标题">
        <Col span="18">
        <Input v-model="formValidate.translate_cover_title" type="textarea" placeholder="请填写翻译后封面标题"></Input>
        </Col>
      </FormItem>

      <FormItem label="文案" prop="org_text" v-if="formValidate.video_work_type != 1">

        <Col span="18">
        <Input v-model="formValidate.org_text" type="textarea" placeholder="请填写文案"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[0]" @click="translate_text(formValidate.org_text, 0)">
          <span v-if="!loadding_array[0]">翻译</span>
          <span v-else>翻译中...</span>
        </Button>
        </Col>

      </FormItem>

      <FormItem label="翻译后文案" prop="translate_text" v-if="formValidate.video_work_type != 1">

        <Col span="18">
        <Input v-model="formValidate.translate_text" type="textarea" placeholder="请填写文案"></Input>
        </Col>

      </FormItem>
      <FormItem label="视频简介" prop="org_video_desc">

        <Col span="18">
        <Input v-model="formValidate.org_video_desc" type="textarea" placeholder="请填写视频简介"></Input>
        </Col>

        <Col span="2" offset="1">
        <Button type="info" :loading="loadding_array[2]" @click="translate_text(formValidate.org_video_desc, 2)">
          <span v-if="!loadding_array[2]">翻译</span>
          <span v-else>翻译中...</span>
        </Button>
        </Col>

      </FormItem>

      <FormItem label="翻译后视频简介" prop="translate_video_desc">
        <Col span="18">
        <Input v-model="formValidate.translate_video_desc" type="textarea" placeholder="请填写视频简介"></Input>
        </Col>
      </FormItem>

      <template v-if="formValidate.video_work_type == 7">

        <Col span='24'>
        <h1>剧本</h1>
        </Col>

        <FormItem label="剧情简介">
          <Col span="18">
          <Input v-model="formValidate.script" disabled type="textarea" placeholder="请填写"></Input>
          </Col>
          <Col span="2" offset="1">
          <Button type="info" :loading="loadding_array[5]" @click="translate_text(formValidate.script, 5)">
            <span v-if="!loadding_array[5]">翻译</span>
            <span v-else>翻译中...</span>
          </Button>
          </Col>
        </FormItem>

        <FormItem label="翻译后剧情简介">
          <Col span="18">
          <Input v-model="formValidate.translate_script" type="textarea" placeholder="请填写"></Input>
          </Col>
        </FormItem>

        <template v-for="(item, index) in formValidate.users">
          <FormItem :label="'角色' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="text" v-model="item.value" disabled placeholder="请填写"></Input>
              </Col>

              <Col span="2" offset="1">
              <Button type="info" :loading="timeLoadding[index]" @click="translate_time_text(item.value, index)">
                <span v-if="!timeLoadding[index]">翻译</span>
                <span v-else>翻译中...</span>
              </Button>
              </Col>
            </Row>
          </FormItem>

          <FormItem :label="'翻译后的角色' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="text" v-model="item.translate_value" placeholder="请填写"></Input>
              </Col>
              <Col span="4" offset="1">
              </Col>
            </Row>
          </FormItem>
        </template>

        <template v-for="(item, index) in formValidate.props">
          <FormItem :label="'道具' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="text" v-model="item.value" disabled placeholder="请填写"></Input>
              </Col>

              <Col span="2" offset="1">
              <Button type="info" :loading="addressLoadding[index]" @click="translate_address_text(item.value, index)">
                <span v-if="!addressLoadding[index]">翻译</span>
                <span v-else>翻译中...</span>
              </Button>
              </Col>
            </Row>
          </FormItem>

          <FormItem :label="'翻译后的道具' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="text" v-model="item.translate_value" placeholder="请填写"></Input>
              </Col>
              <Col span="4" offset="1">
              </Col>
            </Row>
          </FormItem>

        </template>

        <template v-for="(item, index) in formValidate.scripts">
          <FormItem :label="'场景' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="textarea" v-model="item.scene_value" disabled></Input>
              </Col>
              <Col span="2" offset="1">
              <Button type="info" :loading="plotLoadding[index]" @click="translate_plot_text(item.scene_value, index)">
                <span v-if="!plotLoadding[index]">翻译</span>
                <span v-else>翻译中...</span>
              </Button>
              </Col>
            </Row>
          </FormItem>

          <FormItem :label="'翻译后的剧情' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="textarea" v-model="item.translate_scene_value" placeholder="请填写"></Input>
              </Col>
              <Col span="4" offset="1">
              </Col>
            </Row>
          </FormItem>
          <!-- <FormItem
                :label="'剧情描述' + (index + 1)">
            <Row>
                <Col span="18">
                    <Input type="textarea"  v-model="item.desc_value" disabled></Input>
                </Col>
                <Col span="2" offset="1">
                  <Button type="info" :loading="descLoadding[index]" @click="translate_desc_text(item.desc_value, index)">
                    <span v-if="!descLoadding[index]">翻译</span>
                    <span v-else>翻译中...</span>
                  </Button>
                </Col>
            </Row>
          </FormItem>

          <FormItem
              :label="'翻译后的剧情描述' + (index + 1)">
          <Row>
              <Col span="18">
                  <Input type="textarea" v-model="item.translate_desc_value" placeholder="请填写"></Input>
              </Col>
              <Col span="4" offset="1">
              </Col>
          </Row>
        </FormItem> -->

          <FormItem :label="'话术' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="textarea" v-model="item.text_value" disabled></Input>
              </Col>

              <Col span="2" offset="1">
              <Button type="info" :loading="textLoadding[index]" @click="translate_text_text(item.text_value, index)">
                <span v-if="!textLoadding[index]">翻译</span>
                <span v-else>翻译中...</span>
              </Button>
              </Col>

            </Row>
          </FormItem>

          <FormItem :label="'翻译后的话术' + (index + 1)">
            <Row>
              <Col span="18">
              <Input type="textarea" v-model="item.translate_text_value" placeholder="请填写"></Input>
              </Col>
              <Col span="4" offset="1">
              </Col>
            </Row>
          </FormItem>

        </template>

      </template>

      <template v-for="(item, index) in formValidate.goodItems">
        <FormItem :label="'金句评论' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.value" placeholder="请填写"></Input>
            </Col>

            <Col span="2" offset="1">
            <Button type="info" :loading="goodItemLoadding[index]"
              @click="translate_good_comment_text(item.value, index)">
              <span v-if="!goodItemLoadding[index]">翻译</span>
              <span v-else>翻译中...</span>
            </Button>
            </Col>

            <Col span="2" offset="1">
            <Button type="error" @click="handleGoodCommentRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>

        <FormItem :label="'翻译后金句评论' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.translate_value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button long @click="handleGoodAdd" icon="md-add">添加金句评论</Button>
          </Col>
        </Row>
      </FormItem>

      <template v-for="(item, index) in formValidate.blackItems">
        <FormItem :label="'黑粉评论' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.value" placeholder="请填写"></Input>
            </Col>

            <Col span="2" offset="1">
            <Button type="info" :loading="blackItemLoadding[index]"
              @click="translate_black_comment_text(item.value, index)">
              <span v-if="!blackItemLoadding[index]">翻译</span>
              <span v-else>翻译中...</span>
            </Button>
            </Col>

            <Col span="2" offset="1">
            <Button type="error" @click="handleBlackCommentRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>

        <FormItem :label="'翻译后黑粉评论' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.translate_value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button long @click="handleBlackAdd" icon="md-add">添加黑粉评论</Button>
          </Col>
        </Row>
      </FormItem>

      <!-- <FormItem label="翻译后字幕文件" prop="translate_srt_path" v-if="formValidate.video_work_type!=2 && formValidate.video_work_type!=3">
          <input type="file" accept=".srt"  @change="handleTranslateSrtFileChange"/>
      </FormItem> -->
    </Form>

    <Card v-if="tableData.length > 0">
      <tables editable :columns="columns" v-model="tableData" :loading="tableLoading" />
    </Card>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import { getTranslateTextDetail, editTranslateTextTask, sendChatGpt } from "@/api/data";
import { getToken } from '../../libs/util'
import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

export default {
  name: "finance",
  components: {
    Tables
  },
  data() {
    return {
      language: '印尼文',
      loadding_script: false,
      formValidate: {
        id: '',
        org_text: '',
        translate_text: '',
        org_video_title: '',
        translate_title: '',
        cover_title: '',
        translate_cover_title: '',
        title: '',
        translate_video_title: '',
        org_video_desc: '',
        translate_video_desc: '',
        org_srt_path: '',
        translate_srt_path: '',
        blackItems: [],
        goodItems: [],
        scene: '',
        translate_scene: '',
        users: [],
        props: [],
        goodItems: [],
        video_work_type: '',
        scripts: [],
        translate_script: '',
        org_language: 'Chinese',
        keywords: []
      },
      ruleValidate: {
      },
      userLoadding: [],
      propLoadding: [],
      goodItemLoadding: [],
      blackItemLoadding: [],
      page: 1,
      total: 0,
      pageSize: 10,
      status: '',
      addModal: false,
      editModal: false,
      resetFlag: false,
      editUserModal: false,
      editData: {},
      tableLoading: true,
      keep_loading: false,
      allMoney: 0.0,
      classify_id: '',
      startTime: "",
      endTime: "",
      dy_id: '',
      id: '',
      tag_status: '',
      live_id: '',
      tagStatusIds: [],
      tag_id: '',
      blacks: [{ id: 1, name: "是" }, { id: 0, name: "否" }],
      is_black: '',
      tagStatusIds: [{ id: 1, name: "已确认" }, { id: 0, name: "未确认" }],
      selectId: [],
      tag_id: '',
      tagIds: [],
      loadding_array: [false, false, false, false, false, false, false],
      timeLoadding: [],
      addressLoadding: [],
      plotLoadding: [],
      descLoadding: [],
      textLoadding: [],
      loading: false,
      srt_item_loadding_array: [],
      columns: [
        { type: "index", title: '序号', width: 100, align: "center", align: "center" },
        { title: "时间轴", key: "title", editable: true, align: "center", width: 300 },
        { title: "中文话术", key: "text", editable: true, align: "center" },
        {
          title: "翻译", editable: true, align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                    loading: this.srt_item_loadding_array[params.index]
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.translate_srt_text(params.row.text, params.index);
                    }
                  },
                },
                "翻译"
              )
            ]);
          },
        },
        { title: "印尼话术", key: "translate_text", editable: true, align: "center" },
        {
          title: "操作", editable: true, align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: params.row.is_confirm ? "info" : "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.isConfirm(params);
                    },
                  },
                },
                params.row.is_confirm ? "已确认" : "待确认"
              )
            ]);
          },
        },
        {
          title: "修改后", key: "update_translate_text", align: "center", render: (h, params) => {
            return h("Input", {
              props: {
                value: params.row.update_translate_text,
                size: "small",
                type: "textarea"
              }, on: {
                'on-change': (event) => {
                  this.tableData[params.index].update_translate_text = event.target.value;
                }
              }
            })
          }
        }],
      tableData: [],
    };
  },
  methods: {
    async syncPostRequest(text) {
      let data = new FormData();
      data.set("message", text);
      data.set("system", "You will be provided with a sentence in " + this.formValidate.org_language + ", and your task is to translate it into " + this.language)
      // data.set("model", 'gpt-3.5-turbo');
      data.set("model", 'gpt-4-turbo')
      const response = await fetch(baseUrl + "/short_video_task/sendChatGptSystemTranslate", {
        method: 'POST', // 或 'GET'
        headers: {
          'Authorization': getToken()
        },
        body: data,
      });
      return await response.json();
    },
    async keep_translate_text() {
      this.keep_loading = true
      await this.all_translate_text()
    },
    async all_translate_text() {
      try {
        this.loading = !this.keep_loading
        if (this.formValidate.org_video_title != '' && this.formValidate.org_video_title != null) {
          var result = await this.syncPostRequest(this.formValidate.org_video_title)
          if (result.code == 200) {
            this.formValidate.translate_video_title = result.data
          }

        }
        if (this.formValidate.org_title != '' && this.formValidate.org_title != null) {
          var result = await this.syncPostRequest(this.formValidate.org_title)
          if (result.code == 200) {
            this.formValidate.translate_title = result.data
          }
        }

        if (this.formValidate.cover_title != '' && this.formValidate.cover_title != null) {
          var result = await this.syncPostRequest(this.formValidate.cover_title)
          if (result.code == 200) {
            this.formValidate.translate_cover_title = result.data
          }
        }

        if (this.formValidate.org_text != '' && this.formValidate.org_text != null) {
          var result = await this.syncPostRequest(this.formValidate.org_text)
          if (result.code == 200) {
            this.formValidate.translate_text = result.data
          }
        }

        if (this.formValidate.org_video_desc != '' && this.formValidate.org_video_desc != null) {
          if (result.code == 200) {
            this.formValidate.translate_video_desc = result.data
          }
        }

        if (this.formValidate.script != '' && this.formValidate.script != null) {
          var result = await this.syncPostRequest(this.formValidate.script)
          if (result.code == 200) {
            this.formValidate.translate_script = result.data
          }

        }

        if (this.formValidate.scene != '' && this.formValidate.scene != null) {
          var result = await this.syncPostRequest(this.formValidate.scene)
          if (result.code == 200) {
            this.formValidate.translate_scene = result.data
          }
        }

        for (var i = 0; i < this.formValidate.users.length; i++) {
          if (!this.keep_loading || (this.formValidate.users[i].translate_value == '' || this.formValidate.users[i].translate_value == null)) {
            var result = await this.syncPostRequest(this.formValidate.users[i].value)
            if (result.code == 200) {
              this.formValidate.users[i].translate_value = result.data
            }
          }
        }

        for (var i = 0; i < this.formValidate.props.length; i++) {
          if (!this.keep_loading || (this.formValidate.props[i].translate_value == '' || this.formValidate.props[i].translate_value == null)) {
            var result = await this.syncPostRequest(this.formValidate.props[i].value)
            if (result.code == 200) {
              this.formValidate.props[i].translate_value = result.data
            }
          }

        }

        for (var i = 0; i < this.formValidate.scripts.length; i++) {

          if (!this.keep_loading || (this.formValidate.scripts[i].translate_scene_value == '' || this.formValidate.scripts[i].translate_scene_value == null)) {
            var result = await this.syncPostRequest(this.formValidate.scripts[i].scene_value)
            if (result.code == 200) {
              this.formValidate.scripts[i].translate_scene_value = result.data
            }
          }

          if (!this.keep_loading || (this.formValidate.scripts[i].translate_desc_value == '' || this.formValidate.scripts[i].translate_desc_value == null)) {
            var result = await this.syncPostRequest(this.formValidate.scripts[i].desc_value)
            if (result.code == 200) {
              this.formValidate.scripts[i].translate_desc_value = result.data
            }
          }

          if (!this.keep_loading || (this.formValidate.scripts[i].translate_text_value == '' || this.formValidate.scripts[i].translate_text_value == null)) {

            var result = await this.syncPostRequest(this.formValidate.scripts[i].text_value)
            if (result.code == 200) {
              this.formValidate.scripts[i].translate_text_value = result.data
            }
          }

        }

        for (var i = 0; i < this.formValidate.goodItems.length; i++) {
          if (this.formValidate.goodItems[i].value != '' && this.formValidate.goodItems[i].value != null) {

            if (!this.keep_loading || (this.formValidate.goodItems[i].translate_value == '' || this.formValidate.goodItems[i].translate_value == null)) {
              var result = await this.syncPostRequest(this.formValidate.goodItems[i].value)
              if (result.code == 200) {
                this.formValidate.goodItems[i].translate_value = result.data
              }
            }
          }
        }

        for (var i = 0; i < this.formValidate.blackItems.length; i++) {
          if (this.formValidate.blackItems[i].value != '' && this.formValidate.blackItems[i].value != null) {
            if (!this.keep_loading || (this.formValidate.blackItems[i].translate_value == '' || this.formValidate.blackItems[i].translate_value == null)) {
              var result = await this.syncPostRequest(this.formValidate.blackItems[i].value)
              if (result.code == 200) {
                this.formValidate.blackItems[i].translate_value = result.data
              }
            }
          }
        }

        for (var i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].text != '' && this.tableData[i].text != null) {

            console.info(!this.keep_loading)
            console.info(this.tableData[i].translate_text)

            if (!this.keep_loading || (this.tableData[i].translate_text == '' || this.tableData[i].translate_text == null)) {
              var result = await this.syncPostRequest(this.tableData[i].text)
              if (result.code == 200) {
                this.tableData[i].translate_text = result.data
              }
            }
          }
        }

        this.loading = false
        this.keep_loading = false
        this.$Message.success("翻译成功!");
      } catch (err) {
        this.loading = false
        this.keep_loading = false
        this.$Message.error("翻译失败!");
      }

    },
    async translate_time_text(text, index) {
      try {
        if (text == '' || text == undefined) {
          return
        }
        this.$set(this.timeLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.timeLoadding, index, false)
          this.formValidate.users[index].translate_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.timeLoadding, index, false)
      this.$Message.error("翻译失败!");
    },
    async translate_address_text(text, index) {
      try {
        if (text == '') {
          return
        }
        this.$set(this.addressLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.addressLoadding, index, false)
          this.formValidate.props[index].translate_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.addressLoadding, index, false)
      this.$Message.error("翻译失败!");
    },
    async translate_text_text(text, index) {
      try {
        if (text == '') {
          return
        }

        this.$set(this.textLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.textLoadding, index, false)
          this.formValidate.scripts[index].translate_text_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.textLoadding, index, false)
      this.$Message.error("翻译失败!");
    },
    async translate_desc_text(text, index) {
      try {
        if (text == '') {
          return
        }

        this.$set(this.descLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.descLoadding, index, false)
          this.formValidate.scripts[index].translate_desc_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.descLoadding, index, false)
      this.$Message.error("翻译失败!");
    },
    async translate_plot_text(text, index) {
      try {
        if (text == '') {
          return
        }

        this.$set(this.plotLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.plotLoadding, index, false)
          this.formValidate.scripts[index].translate_scene_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.plotLoadding, index, false)
      this.$Message.error("翻译失败!");

    },
    async translate_black_comment_text(text, index) {
      try {
        if (text == '') {
          return
        }
        this.$set(this.blackItemLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.blackItemLoadding, index, false)
          this.formValidate.blackItems[index].translate_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.blackItemLoadding, index, false)
      this.$Message.error("翻译失败!");
    },

    async translate_user_text(text, index) {
      try {
        if (text == '') {
          return
        }

        this.$set(this.userLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.userLoadding, index, false)
          this.formValidate.users[index].translate_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.userLoadding, index, false)
      this.$Message.error("翻译失败!");

    },
    async translate_prop_text(text, index) {
      try {
        if (text == '') {
          return
        }

        this.$set(this.propLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.propLoadding, index, false)
          this.formValidate.props[index].translate_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.propLoadding, index, false)
      this.$Message.error("翻译失败!");

    },
    async translate_good_comment_text(text, index) {

      try {

        if (text == '') {
          return
        }

        this.$set(this.goodItemLoadding, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.goodItemLoadding, index, false)
          this.formValidate.goodItems[index].translate_value = result.data
          return
        }
      } catch (err) {
      }

      this.$set(this.goodItemLoadding, index, false)
      this.$Message.error("翻译失败!");

    },
    async translate_srt_text(text, index) {

      try {

        if (text == '') {
          return
        }

        this.$set(this.srt_item_loadding_array, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.srt_item_loadding_array, index, false)
          this.tableData[index].translate_text = result.data
          return
        }
      } catch (err) {
      }
      this.$set(this.srt_item_loadding_array, index, false)
      this.$Message.error("翻译失败!");

    },
    async translate_text(text, index) {

      try {

        if (text == '') {
          return
        }

        this.$set(this.loadding_array, index, true)
        var result = await this.syncPostRequest(text)
        if (result.code == 200) {
          this.$Message.success("翻译成功!");
          this.$set(this.loadding_array, index, false)
          if (index == 0) {
            this.formValidate.translate_text = result.data
          } else if (index == 1) {
            this.formValidate.translate_video_title = result.data
          } else if (index == 2) {
            this.formValidate.translate_video_desc = result.data
          } else if (index == 3) {
            this.formValidate.translate_title = result.data
          } else if (index == 4) {
            this.formValidate.translate_scene = result.data
          } else if (index == 5) {
            this.formValidate.translate_script = result.data
          }else if (index == 6) {
            this.formValidate.translate_cover_title = result.data
          }
          return
        }
      } catch (err) {
      }
      this.$set(this.loadding_array, index, false)
      this.$Message.error("翻译失败!");
    },
    isConfirm(params) {
      if (params.row.translate_text == '' || params.row.translate_text == undefined) {
        this.$Message.error("翻译后的文本不能为空");
        return
      }
      this.tableData[params.index].is_confirm = !params.row.is_confirm
    },
    async confirmSrtTranslateContent() {
      var srtContent = this.generateSRT(this.tableData)
      const blob = new Blob([srtContent], { type: 'text/plain' });
      // 保存文件
      // saveAs(blob, 'subtitles.srt');
    },
    handleGoodAdd() {
      this.formValidate.goodItems.push({ "value": '', "translate_value": '' })
      this.goodItemLoadding.push(false)
    },
    handleBlackAdd() {
      this.formValidate.blackItems.push({ "value": '', "translate_value": '' })
      this.blackItemLoadding.push(false)
    },

    handleUserRemove(index) {
      this.formValidate.users.splice(index, 1)
      this.userLoadding.splice(index, 1)
    },
    handlePropRemove(index) {
      this.formValidate.props.splice(index, 1)
      this.propLoadding.splice(index, 1)
    },

    handleGoodCommentRemove(index) {
      this.formValidate.goodItems.splice(index, 1)
      this.goodItemLoadding.splice(index, 1)

    },
    handleBlackCommentRemove(index) {
      this.formValidate.blackItems.splice(index, 1)
      this.blackItemLoadding.splice(index, 1)
    },
    async handleTranslateSrtFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;

      // 解析srt文件
      const reader = new FileReader();
      var srtText = ''
      reader.onload = e => {
        srtText = e.target.result;
        var srt_array = this.parseSRT(srtText)
        for (var i = 0; i < srt_array.length; i++) {
          var item = srt_array[i]
          this.tableData[i].translate_text = item.text
          this.tableData[i].after_text = ""
        }
      };
      reader.readAsText(file)

    }, generateSRT(subtitles) {
      let srtContent = '';
      subtitles.forEach((subtitle, index) => {
        const sequenceNumber = index + 1;
        const startTime = subtitle.startTime
        const endTime = subtitle.endTime
        srtContent += `${sequenceNumber}\n${startTime} --> ${endTime}\n${subtitle.translate_text}\n\n`;
      });
      return srtContent;
    }, parseSRT(content) {
      // 按行拆分内容
      const lines = content.trim().split(/\r?\n/);
      const subtitles = [];

      // 用于临时存储每个字幕块的变量
      let subtitleBlock = {
        index: null,
        startTime: null,
        endTime: null,
        text: ''
      };

      // 遍历每一行内容
      lines.forEach(line => {
        if (!subtitleBlock.index) {
          // 解析字幕序号
          subtitleBlock.index = parseInt(line);
        } else if (!subtitleBlock.startTime) {
          // 解析时间轴的起始时间
          const [startTime, endTime] = line.split(' --> ').map(time => time.trim());
          subtitleBlock.startTime = startTime;
          subtitleBlock.endTime = endTime;
        } else if (line.trim() === '') {
          // 遇到空行时，保存当前字幕块并重置临时变量
          subtitles.push(subtitleBlock);
          subtitleBlock = {
            index: null,
            startTime: null,
            endTime: null,
            text: ''
          };
        } else {
          // 解析字幕文本内容
          subtitleBlock.text += line.trim() + ' ';
        }
      });

      return subtitles;
    }, handleSubmit(name) {
      var formValidate = this.formValidate
      var blackItems = formValidate.blackItems
      var goodItems = formValidate.goodItems
      var scene = {
        users: this.formValidate.users,
        props: this.formValidate.props,
        scripts: this.formValidate.scripts,
        product: this.formValidate.product,
        product_url: this.formValidate.product_url,
        script: this.formValidate.script,
        translate_script: this.formValidate.translate_script,
        keywords: this.formValidate.keywords
      }

      const data = {
        black_comment: JSON.stringify(blackItems),
        good_comment: JSON.stringify(goodItems),
        org_video_desc: formValidate.org_video_desc,
        translate_video_desc: formValidate.translate_video_desc,
        org_video_title: formValidate.org_video_title,
        translate_video_title: formValidate.translate_video_title,
        cover_title: formValidate.cover_title,
        translate_cover_title: formValidate.translate_cover_title,
        org_text: formValidate.org_text,
        translate_text: formValidate.translate_text,
        srt_json: JSON.stringify(this.tableData),
        org_title: formValidate.org_title,
        translate_title: formValidate.translate_title,
        scene_json: JSON.stringify(scene),
        translate_scene: formValidate.translate_scene,
      };

      editTranslateTextTask(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },
    handleReset(name) {
      this.$refs[name].resetFields()
    },
    translate(params) {

    }, covertTime(time_str) {
      var start_split = time_str.split(":")

      // 00:00:15,000  解析这个格式，转换成毫秒
      if (start_split.length > 2) {
        var hour_second = parseInt(start_split[0]) * 60 * 60 * 1000
        var m_second = parseInt(start_split[1]) * 60 * 1000
        var second_split = start_split[2].split(",")
        var second = 0
        var mm_second = 0
        if (second_split.length > 1) {
          second = parseInt(second_split[0]) * 1000
          mm_second = parseInt(second_split[1])
        }
        return hour_second + m_second + second + mm_second + ""
      }
    }, setEditData(params) {
      this.formValidate.id = params.id.toString()
      this.formValidate.org_text = params.org_text
      this.formValidate.translate_text = params.translate_text
      this.formValidate.org_video_title = params.org_video_title
      this.formValidate.translate_video_title = params.translate_video_title
      this.formValidate.translate_cover_title = params.translate_cover_title
      this.formValidate.cover_title = params.cover_title
      this.formValidate.org_title = params.org_title
      this.formValidate.translate_title = params.translate_title
      this.formValidate.org_video_desc = params.org_video_desc
      this.formValidate.scene = params.scene
      this.formValidate.translate_scene = params.translate_scene
      this.formValidate.translate_video_desc = params.translate_video_desc
      this.status = params.status
      this.formValidate.video_work_type = params.checkSrtTask.shortVideoTask.short_video_work_type_id
      this.formValidate.org_language = params.checkSrtTask.shortVideoTask.language

      if (params.srt_json != null) {
        var srt_array = JSON.parse(params.srt_json)
        this.tableData = []
        if (srt_array != null && srt_array != undefined) {
          for (var i = 0; i < srt_array.length; i++) {
            var item = srt_array[i]
            var endTime = this.covertTime(item.endTime)
            var startTime = this.covertTime(item.startTime)
            this.tableData.push({ "title": item.startTime + "---" + item.endTime + "长度:" + (endTime - startTime) + "毫秒", "text": item.text, "update_translate_text": "", "translate_text": "", "startTime": item.startTime, 'endTime': item.endTime, "is_confirm": '' })
            this.srt_item_loadding_array.push(false)
          }
        }
      }

      if (params.translate_srt_json != null) {
        var srt_array = JSON.parse(params.translate_srt_json)

        if (srt_array != null && srt_array != undefined) {
          for (var i = 0; i < srt_array.length; i++) {
            var item = srt_array[i]
            if (i >= this.tableData.length) {
              break
            }
            this.tableData[i].translate_text = item.translate_text
            this.tableData[i].update_translate_text = item.update_translate_text
            this.tableData[i].is_confirm = item.is_confirm
          }
        }
      }

      if (params.good_comment != null && params.good_comment != 'null') {
        this.formValidate.goodItems = JSON.parse(params.good_comment)
        if (this.formValidate.goodItems != null && this.formValidate.goodItems != undefined) {
          for (var i = 0; i < this.formValidate.goodItems.length; i++) {
            this.goodItemLoadding.push(false)
          }
        }
      }

      if (params.black_comment != null && params.black_comment != 'null') {
        this.formValidate.blackItems = JSON.parse(params.black_comment)

        if (this.formValidate.blackItems != null && this.formValidate.blackItems != undefined) {
          for (var i = 0; i < this.formValidate.blackItems.length; i++) {
            this.blackItemLoadding.push(false)
          }
        }
      }

      if (params.scene_json != null && params.scene_json != 'null' && params.scene_json != '{}' && params.scene_json != '[]' && params.scene_json != '') {
        var scene = JSON.parse(params.scene_json)
        this.formValidate.scripts = scene.scripts
        this.formValidate.users = scene.users
        this.formValidate.props = scene.props
        this.formValidate.script = scene.script
        this.formValidate.translate_script = scene.translate_script
        this.formValidate.product_url = scene.product_url
        this.formValidate.product = scene.product
        this.formValidate.keywords = scene.keywords

        if (this.formValidate.scripts != null && this.formValidate.scripts != undefined) {
          for (var i = 0; i < this.formValidate.scripts.length; i++) {
            this.plotLoadding.push(false)
            this.descLoadding.push(false)
            this.textLoadding.push(false)
          }
        }

        if (this.formValidate.users != null && this.formValidate.users != undefined) {
          for (var i = 0; i < this.formValidate.users.length; i++) {
            this.timeLoadding.push(false)
          }
        }

        if (this.formValidate.props != null && this.formValidate.props != undefined) {
          for (var i = 0; i < this.formValidate.props.length; i++) {
            this.userLoadding.push(false)
          }
        }
      }
    },
    backHistory() {
      this.$router.go(-1);
    },
    setTableLoading(state) {
      this.tableLoading = state;
    }, getDetail() {
      var params = {
        id: this.id
      }
      getTranslateTextDetail(params).then((res) => {
        if (res.data.code == 200) {
          var detailData = res.data.data
          this.setEditData(detailData)
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });

    }
  },
  mounted() {
    this.id = this.$route.query.id;
    this.language = this.$route.query.language;

    if (this.language == null) {
      this.language = 'Indonesia'
    }

    this.getDetail()
  },
};
</script>
